{
    "OnavailablestateLabel": "On Available State Over:",
    "OnbusystateLabel": "On Busy State Over:",
    "OnnaordndstateLabel": "On N/A or DND State Over:",
    "OnwrapupLabel": "On Wrap-Up State Over:",
    "OnavailablestateEnabledHiddenlabel": "Is On Available State Over Setting Enabled?",
    "OnbusystateEnabledHiddenlabel": "Is On Busy State Over Setting Enabled?",
    "OnnaordndstateEnabledHiddenlabel": "Is On N/A or DND State Over Setting Enabled?",
    "OnwrapupEnabledHiddenlabel": "Is On Wrap-Up State Over Setting Enabled?",
    "OnavailablestatePlaceholder": "30s",
    "OnbusystatePlaceholder": "5m 0s",
    "OnnaordndstatePlaceholder": "3m 0s",
    "OnwrapupPlaceholder": "3m 0s",
    "NAME": "ACDStateThresholds",
    "ACDStateThresholds_SectionHeader": "ACD State Thresholds",
    "ACDStateThresholds_SectionPara": "You can activate alarms when agents remain in a particular ACD state for too long. Choose the ACD states that will activate an alarm below and then choose the required activation duration."
}